export default "__VITE_ASSET__BTYdSy7k__"